function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(-269.822 -160.069)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M286.822,161.079l-10-.01a2.006,2.006,0,0,0-2,2v18a2.006,2.006,0,0,0,2,2h10a2.006,2.006,0,0,0,2-2v-18A2,2,0,0,0,286.822,161.079Zm0,16.99h-10v-12h10Zm-7.5-9.5h1.75a.755.755,0,0,0,.75-.75h0a.755.755,0,0,0-.75-.75h-2.5a.755.755,0,0,0-.75.75v2.5a.755.755,0,0,0,.75.75h0a.755.755,0,0,0,.75-.75Zm3.25,8.5h2.5a.755.755,0,0,0,.75-.75v-2.5a.755.755,0,0,0-.75-.75h0a.755.755,0,0,0-.75.75v1.75h-1.75a.755.755,0,0,0-.75.75h0A.755.755,0,0,0,282.572,177.069Z",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_25",
  "data-name": "Rectangle 25",
  width: 24,
  height: 24,
  fill: "none"
});

function SvgDevicesFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Devices",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesFocused);
export default __webpack_public_path__ + "static/media/devices_focused.ac4b2aa8.svg";
export { ForwardRef as ReactComponent };